import universalDesignSystem from '@/config/colorPallets/universalDesignSystem';
import { transparentize } from '@/utils/colors';
import { fadeColor } from '@/utils/gradient';
import { isDashedBorder } from '@/components/Editor/Form/fields/common/Border/utils';
import BorderFields, { BorderStyle } from '@/components/Editor/Form/fields/common/Border';
import ColorPicker from '../common/ColorPicker';
import borderStyles from '@/components/Editor/Form/fields/common/Border/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DEFAULT_COLOR = transparentize(universalDesignSystem.primary, 1);
const DEFAULT_GRADIENT_COLOR = fadeColor(universalDesignSystem.primary);
const COLOR_PICKER_DEFAULTS = {
  gradient: DEFAULT_GRADIENT_COLOR,
  solid: DEFAULT_COLOR
};

const EditorFieldsLineStyles = _ref => {
  let {
    nameSpace,
    lineDash,
    lineColor,
    lineBackgroundColor,
    lineWidth,
    colorPallet = [],
    enableGradientPicker = true,
    defaults = {},
    onChange
  } = _ref;
  const lineBackgroundFieldId = `${nameSpace}-line-background-color`;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(BorderFields, {
      nameSpace: nameSpace,
      width: lineWidth,
      style: isDashedBorder(lineDash ?? defaults.lineDash) ? BorderStyle.Dashed : undefined,
      color: lineColor || '',
      backgroundColor: lineBackgroundColor || '',
      colorPallet: colorPallet,
      enabledButtonStyles: [BorderStyle.Solid, BorderStyle.Dashed],
      pill: false,
      defaults: {
        color: defaults.lineColor || colorPallet[0]
      },
      textOverrides: {
        clearBorder: 'Reset to default',
        colorPickerLabel: 'Line Color',
        colorPickerCaption: 'Optional Line Color',
        widthPlaceholder: `${defaults.lineWidth ?? 1}`
      },
      minWidth: 1,
      onChangeColor: borderColor => onChange({
        lineColor: borderColor
      }),
      onChangeStyle: borderStyle => onChange({
        lineDash: borderStyle === BorderStyle.Dashed ? [5, 5] : [0, 0]
      }),
      onChangeWidth: borderWidth => onChange({
        lineWidth: borderWidth
      }),
      onDelete: () => onChange({
        lineColor: null,
        lineDash: null,
        lineWidth: null,
        lineBackgroundColor: null
      }),
      children: /*#__PURE__*/_jsx(ColorPicker, {
        id: lineBackgroundFieldId,
        label: "Area Color",
        caption: "Optional line fill color",
        className: borderStyles.colorPicker,
        defaultValue: lineBackgroundColor || defaults.lineBackgroundColor,
        enableGradientPicker: enableGradientPicker,
        defaults: COLOR_PICKER_DEFAULTS,
        onChange: color => onChange({
          lineBackgroundColor: typeof color === 'string' ? color : null
        })
      }, lineBackgroundFieldId)
    })
  });
};

export default EditorFieldsLineStyles;